export const FORM_OF_OFFER = [
  { id: 'PUBLIC', displayValue: 'Public' },
  { id: 'PRIVATE', displayValue: 'Private' },
];
